export default "__VITE_ASSET__CGDFxDs1__"